import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '../fragments';

export default gql`
  mutation updatePartnerLocationCaseSetting(
    $input: PartnerLocationCaseSettingUpdateInput!
  ) {
    updatePartnerLocationCaseSetting(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerLocation {
        id
        settingGroupOptionIds
      }
    }
  }
  ${ErrorMessageInfo}
`;
